/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { createSlice } from "@reduxjs/toolkit";
import { WORKSTATION_ROOM } from "../../../rooms/RoomNameConstants";
import WorkstationRoomInitState from "../../../rooms/WorkstationRoom/state";

const initialState = { ...WorkstationRoomInitState };

const workstationRoomSlice = createSlice({
    name: WORKSTATION_ROOM,
    initialState: initialState,
    reducers: {
        setCriticalJobsData: (state, action) => {
            const { field, data } = action.payload
            state.criticalJobsData[field] = data
        },
        setSelectedWorkstation: (state, action) => {
            state.selectedWorkstation = action.payload
        },
        setBarPanelData: (state, action) => {
            state.barPanelData = action.payload
        },
        resetInitialWorkstationRoom: (state) => {
            Object.assign(state, initialState)
        },
        loadRemoteWorkstationRoom: (state, action) => {
            Object.assign(state, action.payload)
        }
    }
});

export const {
    setCriticalJobsData,
    resetInitialWorkstationRoom,
    loadRemoteWorkstationRoom,
    setSelectedWorkstation,
    setBarPanelData,
} = workstationRoomSlice.actions;

export default workstationRoomSlice;
